<script setup>
  const { item } = defineProps(['item']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <FighterStatCard :title="item.title" :subtitle="item.subtitle">
    <h5>{{ item.data.value }}</h5>
  </FighterStatCard>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  .stat {
    h5 {
      margin-top: px(-72);
    }
  }
</style>
